var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.iframeQuickId || _vm.srcgame),expression:"iframeQuickId || srcgame"}],staticClass:"kejian",class:{ kejian_game: _vm.gameName },style:({ background: _vm.preClassTestBg })},[(_vm.srcgame)?_c('iframe',{staticClass:"iframe_game kejian-zindex'",attrs:{"allowtransparency":"true","src":_vm.srcgame}}):_c('iframe',{staticClass:"iframe_kejian",class:{
      'kejian-zindex':
        _vm.byiframe != 'https://about:blank' &&
        _vm.loadData[_vm.qid] &&
        _vm.loadData[_vm.qid].state,
    },attrs:{"allowtransparency":"true","src":_vm.byiframe}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f64246","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/video/answer/kejian.vue
// module id = null
// module chunks = 